//@flow
import * as React from "react";
import "./style.css";
import {
  UICoreBox,
  UICoreText,
  UICoreImage,
  UICoreButton,
  UICoreReorderable
} from "../../UICore";
import WithStyles from "../../../Helper_HOC/WithStyles";
import { type formStyleType } from "../../../FlowTypes/wispformStyleTypes";
import { connect } from "react-redux";
import {
  updateQuestionContent,
  updateQuestionContentWithouPersistence
} from "../../../Pages/FormBuilderPage/States/actions";
import {
  removeElemenent,
  replace,
  toArray,
  swap,
  safeGet,
  isNonEmptyArray
} from "../../../Library/Util";
import UI_PictureChoiceSingleChoice, {
  type pictureChoice
} from "./UI_PictureChoiceSingleChoice";
import { type questionConfig } from "../../../Pages/QuestionTypes";
import UI_SubmitMultiSelectFooter from "../UI_SubmitMultiSelectFooter";

export type choiceAnswerType = {|
  choiceContent: string,
  index: number
|};

type answerType = Array<choiceAnswerType>;

type questionAnswerType = {|
  answer: Array<answerType>,
  question_id: string,
  title: string,
  type: string
|};

type Props = {|
  contents: Array<pictureChoice>,
  answerPrimaryColor: string,
  answerSecondaryColor: string,
  styles: formStyleType,
  config: questionConfig,
  pageNumber: number,
  isInBuilder: boolean,
  isCurrentQuestion: boolean,
  updatePictureChoices: (number, Array<pictureChoice>) => void,
  updatePictureChoicesWithouPersistence: (number, Array<pictureChoice>) => void,
  onQuestionComplete?: (?answerType) => mixed,
  onQuestionUpdate?: (?answerType, boolean) => mixed,
  answer?: questionAnswerType
|};
type State = {||};

class UI_PictureChoice extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  _addPicChoice = () => {
    this.props.updatePictureChoices(this.props.pageNumber, [
      ...this.props.contents,
      {
        text: "",
        imageUrl: ""
      }
    ]);
  };

  _renderAddPictureChoiceButton = () => {
    return (
      <UICoreBox className="UI_PictureChoice-Add" padding="xm" width="50%">
        <UICoreBox
          shape="rounded"
          hexColor={this.props.answerSecondaryColor}
          padding="xm"
          height="100%"
          justifyContent="center"
          alignItems="center"
          onClick={this._addPicChoice}
        >
          <UICoreBox
            minHeight="150px"
            justifyContent="center"
            alignItems="center"
            padding="sm"
          >
            <UICoreBox name="plusIcon">
              <i
                style={{ color: this.props.styles.answer }}
                className="ion-plus UI_PictureChoice-Plus"
              />
            </UICoreBox>
            <UICoreBox>
              <UICoreText hexColor={this.props.styles.answer}>
                Add a choice
              </UICoreText>
            </UICoreBox>
          </UICoreBox>
        </UICoreBox>
      </UICoreBox>
    );
  };

  _removePictureChoice = (index: number) => {
    this.props.updatePictureChoices(
      this.props.pageNumber,
      removeElemenent(this.props.contents, index)
    );
  };

  _updateChoiceText = (index: number, text: string) => {
    this.props.updatePictureChoices(
      this.props.pageNumber,
      replace(
        this.props.contents,
        { ...this.props.contents[index], text: text },
        index
      )
    );
  };

  _updateChoiceTextWithoutPersistence = (index: number, text: string) => {
    this.props.updatePictureChoicesWithouPersistence(
      this.props.pageNumber,
      replace(
        this.props.contents,
        { ...this.props.contents[index], text: text },
        index
      )
    );
  };

  _updateChoicePic = (index: number, picUrl: string) => {
    this.props.updatePictureChoices(
      this.props.pageNumber,
      replace(
        this.props.contents,
        { ...this.props.contents[index], imageUrl: picUrl },
        index
      )
    );
  };

  _getMultiSelectAnswers = (index: number, text: string): answerType => {
    const selectedChoices = toArray(
      // $FlowFixMe
      safeGet(_ => this.props.answer.answer)
    );
    const isAlreadySelected = selectedChoices.some(
      answer => answer.index === index
    );
    if (isAlreadySelected) {
      return selectedChoices.filter(answer => answer.index !== index);
    } else {
      return [
        ...selectedChoices,
        {
          choiceContent: text,
          index: index
        }
      ];
    }
  };

  _renderMultiSelectSubmitFooter = () => {
    const isMultiSelect =
      this.props.config && this.props.config["Multiple Selection"];
    if (
      this.props.isCurrentQuestion &&
      isMultiSelect && // $FlowFixMe
      isNonEmptyArray(safeGet(_ => this.props.answer.answer))
    ) {
      return (
        <UI_SubmitMultiSelectFooter
          onClick={() => {
            this.props.onQuestionComplete &&
              // $FlowFixMe
              this.props.onQuestionComplete(this.props.answer.answer);
          }}
        />
      );
    }
  };

  _onChoiceClick = (index: number, text: string) => {
    if (safeGet(_ => this.props.config["Multiple Selection"])) {
      this.props.onQuestionUpdate &&
        // $FlowFixMe
        this.props.onQuestionUpdate(
          this._getMultiSelectAnswers(index, text),
          true
        );
    } else {
      this.props.onQuestionComplete &&
        this.props.onQuestionComplete([{ choiceContent: text, index: index }]);
    }
  };

  _isSelected = (index: number): boolean => {
    if (this.props.isInBuilder) return false;
    return toArray(this.props.answer && this.props.answer.answer).some(
      (answer: choiceAnswerType) => answer.index === index
    );
  };

  _onSortEnd = (
    info: {
      oldIndex: number,
      newIndex: number,
      collection: Array<any>,
      isKeySorting: boolean
    },
    e: HTMLElement
  ) => {
    this.props.updatePictureChoices(
      this.props.pageNumber,
      swap(this.props.contents, info.oldIndex, info.newIndex)
    );
  };

  _getUICoreReorderableKey = () => {
    //we need to make sure UICoreReorderable is re executed after switch between questions and new pic choice is added
    return this.props.pageNumber + " " + toArray(this.props.contents).length;
  };

  render() {
    return (
      <UICoreBox
        className="UI_PictureChoice-Container"
        direction="row"
        width="100%"
      >
        {!this.props.isInBuilder && this._renderMultiSelectSubmitFooter()}
        {this.props.isInBuilder ? (
          <UICoreReorderable
            key={this._getUICoreReorderableKey()}
            direction="both"
            onSortEnd={this._onSortEnd}
            disableLast={true}
          >
            {[
              ...this.props.contents.map(
                (pictureChoice: pictureChoice, index: number) => {
                  return (
                    <UI_PictureChoiceSingleChoice
                      onChoiceClick={() =>
                        this._onChoiceClick(index, pictureChoice.text)
                      }
                      isInBuilder={this.props.isInBuilder}
                      key={index}
                      choicePicUrl={pictureChoice.imageUrl}
                      choiceText={pictureChoice.text}
                      answerPrimaryColor={this.props.answerPrimaryColor}
                      answerSecondaryColor={this.props.answerSecondaryColor}
                      styles={this.props.styles}
                      removePictureChoice={() =>
                        this._removePictureChoice(index)
                      }
                      updateChoiceText={(text: string) =>
                        this._updateChoiceText(index, text)
                      }
                      updateChoiceTextWithoutPersistence={(text: string) =>
                        this._updateChoiceTextWithoutPersistence(index, text)
                      }
                      updateChoicePic={(imageUrl: string) =>
                        this._updateChoicePic(index, imageUrl)
                      }
                      isSelected={false}
                    />
                  );
                }
              ),
              this._renderAddPictureChoiceButton()
            ]}
          </UICoreReorderable>
        ) : (
          this.props.contents.map(
            (pictureChoice: pictureChoice, index: number) => {
              return (
                <UI_PictureChoiceSingleChoice
                  onChoiceClick={() =>
                    this._onChoiceClick(index, pictureChoice.text)
                  }
                  isInBuilder={this.props.isInBuilder}
                  key={index}
                  choicePicUrl={pictureChoice.imageUrl}
                  choiceText={pictureChoice.text}
                  answerPrimaryColor={this.props.answerPrimaryColor}
                  answerSecondaryColor={this.props.answerSecondaryColor}
                  styles={this.props.styles}
                  removePictureChoice={() => this._removePictureChoice(index)}
                  updateChoiceText={(text: string) =>
                    this._updateChoiceText(index, text)
                  }
                  updateChoiceTextWithoutPersistence={(text: string) =>
                    this._updateChoiceTextWithoutPersistence(index, text)
                  }
                  updateChoicePic={(imageUrl: string) =>
                    this._updateChoicePic(index, imageUrl)
                  }
                  isSelected={this._isSelected(index)}
                />
              );
            }
          )
        )}
      </UICoreBox>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updatePictureChoices: (
      pageNumber: number,
      pictureChoices: Array<pictureChoice>
    ) => {
      dispatch(updateQuestionContent(pageNumber, pictureChoices, true));
    },
    updatePictureChoicesWithouPersistence: (
      pageNumber: number,
      pictureChoices: Array<pictureChoice>
    ) => {
      dispatch(
        updateQuestionContentWithouPersistence(pageNumber, pictureChoices)
      );
    }
  };
};

export default WithStyles(connect(null, mapDispatchToProps)(UI_PictureChoice));
